import { Card } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Sparkles, Home, Handshake, Plug } from "lucide-react";

const NOVITA = [
  {
    id: "danni-beni",
    icon: Home,
    titolo: "Preventivo Danni ai Beni più completo",
    data: "Ottobre 2026",
    punti: [
      "Ora puoi indicare dove si trova davvero il fabbricato da assicurare, anche quando è diverso dalla sede legale del cliente.",
      "Nel preventivo trovi l'interruttore «L'ubicazione coincide con la sede legale»: se il rischio è altrove, lo spegni e inserisci via, CAP, comune e provincia.",
      "Il PDF mostra l'ubicazione del rischio, la decorrenza/durata della copertura e i dati del distributore.",
      "È stato tolto il «rischio locativo» (era fonte di problemi per cliente e intermediario).",
      "Nel pacchetto documenti per il cliente è inclusa l'informativa Privacy di Assietica.",
    ],
  },
  {
    id: "vetrina-coop",
    icon: Handshake,
    titolo: "Vetrina «Cooperative Convenzionate»",
    data: "Ottobre 2026",
    punti: [
      "Esiste una vetrina pubblica con l'elenco delle cooperative convenzionate (nome ed eventuale badge «Confcooperative»).",
      "Il convenzionato clicca sulla propria cooperativa e arriva al percorso Rete Solidale già impostato sulla sua convenzione, pronto per chiedere il preventivo.",
      "L'appartenenza resta dichiarata dal cliente e verificata prima dell'emissione. In vetrina non compare nessun prezzo o sconto.",
      "La vetrina può essere mostrata anche sul sito Assietica.it.",
    ],
  },
  {
    id: "integrazione",
    icon: Plug,
    titolo: "Collegamento con sistemi esterni (solo Agenzia)",
    data: "Ottobre 2026",
    punti: [
      "L'Agenzia può autorizzare un sistema esterno fidato a leggere il catalogo prodotti e le tariffe, con una «tessera» revocabile in qualsiasi momento.",
      "Per te come Partner non cambia nulla: continui ad accedere al portale normalmente con le tue credenziali.",
    ],
  },
];

export function WhatsNewGuide() {
  return (
    <Card className="overflow-hidden rounded-2xl border-terracotta/30 bg-gradient-to-br from-sage/40 to-white" data-testid="whats-new">
      <div className="flex items-center gap-2 border-b border-border/60 px-5 py-4">
        <Sparkles className="h-5 w-5 text-terracotta" />
        <h2 className="font-heading text-lg font-semibold text-forest">Ultime novità del Portale</h2>
      </div>
      <Accordion type="single" collapsible className="px-5 py-2">
        {NOVITA.map((n) => (
          <AccordionItem key={n.id} value={n.id} data-testid={`whats-new-${n.id}`}>
            <AccordionTrigger className="hover:no-underline">
              <span className="flex items-center gap-3 text-left">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white text-forest shadow-sm">
                  <n.icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                </span>
                <span>
                  <span className="block font-heading text-base font-semibold text-forest">{n.titolo}</span>
                  <span className="block text-xs text-muted-foreground">{n.data}</span>
                </span>
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <ul className="ml-12 list-disc space-y-1.5 pr-2 text-sm text-forest/80">
                {n.punti.map((p, i) => <li key={i}>{p}</li>)}
              </ul>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Card>
  );
}
